import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import Row from './Row'

export default class RowGroupHeader extends React.Component {
  static propTypes = {
    onClick: PropTypes.func
  }

  render() {
    const {onClick} = this.props

    return (
      <Row className='table-row-group-header' onClick={onClick}>
        <Icon name='chevron' className='table-row-group-header_icon' size='10px' />
        {this.props.children}
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Table/RowGroupHeader.js